


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getList: '/div/paginated',
    getById: '/div/id',
    create: '/div/save',
    update: '/div/update',
    delete: '/div/delete',
}

const useDivisionRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getDivisionList = async (payload) => {
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getDivisionById = async (payload) => {
        return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const createDivision = async (payload) => {
        return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const updateDivision = async (payload) => {
        return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const deleteDivision = async (payload) => {
        return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    return {
        isLoading,
        data,
        error,
        getDivisionList,
        getDivisionById,
        createDivision,
        updateDivision,
        deleteDivision
    }
}

export default useDivisionRepo
